import notification from '@/assets/notification/successnotification.mp3'

export default {
  methods: {
    ringSuccessBell() {
      const audio = new Audio(notification)
      audio.play()
    },
  },
}
